export default __webpack_public_path__ + "static/img/28.727d6da.png";